import { createContext } from 'react'

export const TableContext = createContext()

export const TableProvider = ({ children, ...props }) => (
  <TableContext.Provider {...props}>
    { children }
  </TableContext.Provider>
)
